import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useResourceDocumentDataContextSafe } from '../../../context/resourceDataContext.js';
import { ResourceContentDocumentPDF } from './PDF/ResourceContentDocumentPDF.js';
import { ResourceCode } from './ResourceCode.js';
import { ResourceDocx } from './ResourceDocx.js';
import { ResourceMarkdown } from './ResourceMarkdown.js';
import { ResourcePlainText } from './ResourcePlainText.js';
import { useQueryDocumentResourceFileContent } from '../../../../queries/useQueryDocumentResourceFileContent.js';
import { isResourceDetailDocumentPDF, isResourceDetailDocumentHTML, isResourceDetailDocumentJSON, isResourceDetailDocumentMarkdown, isResourceDetailDocumentDOCX, isResourceDetailDocumentText, isResourceDetailDocumentCsv, isResourceDetailDocumentWithGeneratedPDFPreview } from '../../../../../resources/documentGuards.js';
import { HeaderWrapper } from '../../components/ModalResourceHeader.js';
import { ExpandedResourceDropdownMenu } from '../../components/ExpandedResourceDropdownMenu.js';
import { ExpandedResourceTitle } from '../../components/ResourceTitle.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { maxDocumentPreviewSize } from '../../../../resource-details.config.js';
import FileDisplay from '../../../../../resources/components/FileDisplay.js';
import Badge from '@fabric-app/ui/components/Badge';
import { ResourceContentDocumentWithGeneratedPDF } from './PDF/ResourceContentDocumentWithGeneratedPDF.js';

const ResourceContentDocument = () => {
  const { resource, handleDownload } = useResourceDocumentDataContextSafe();
  const { data: fileContent, isLoading } = useQueryDocumentResourceFileContent(resource, {
    enabled: !isResourceDetailDocumentPDF(resource) && !resource.data.pdfRender?.url
  });
  if (isResourceDetailDocumentPDF(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentDocumentPDF, {});
  }
  if (resource.data.pdfRender?.url) {
    return /* @__PURE__ */ jsx(ResourceContentDocumentWithGeneratedPDF, {});
  }
  const isCode = isResourceDetailDocumentHTML(resource) || isResourceDetailDocumentJSON(resource);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(HeaderWrapper, {
        children: [
          /* @__PURE__ */ jsx(HeaderWrapper.Left, {
            children: fileContent && /* @__PURE__ */ jsx(ExpandedResourceTitle, {})
          }),
          /* @__PURE__ */ jsx(HeaderWrapper.Right, {
            children: /* @__PURE__ */ jsx(ExpandedResourceDropdownMenu, {})
          })
        ]
      }),
      isResourceDetailDocumentMarkdown(resource) && fileContent && /* @__PURE__ */ jsx(ResourceMarkdown, {}),
      isCode && fileContent && /* @__PURE__ */ jsx(ResourceCode, {}),
      isResourceDetailDocumentDOCX(resource) && fileContent && /* @__PURE__ */ jsx(ResourceDocx, {}),
      (isResourceDetailDocumentText(resource) || isResourceDetailDocumentCsv(resource)) && fileContent && /* @__PURE__ */ jsx(ResourcePlainText, {}),
      isLoading && !fileContent && /* @__PURE__ */ jsx(Flex, {
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
        children: /* @__PURE__ */ jsx(Spinner, {})
      }),
      !fileContent && !isLoading && /* @__PURE__ */ jsxs(Flex, {
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
        gap: "elementsContainer",
        direction: "column",
        "data-pan-id-ignore-resource-drag-resize": "xy",
        children: [
          !isResourceDetailDocumentWithGeneratedPDFPreview(resource) && (resource.size ?? 0) > maxDocumentPreviewSize && /* @__PURE__ */ jsx(StyledLargeBadge, {
            variant: "bg-primary-reverse",
            size: "medium",
            children: "File is too large to preview"
          }),
          /* @__PURE__ */ jsx(FileDisplay, {
            fileExtension: resource.extension,
            fileName: resource.name || "untitled",
            onClick: handleDownload
          })
        ]
      })
    ]
  });
};
const StyledLargeBadge = styled(Badge.Static).withConfig({
  displayName: "ResourceContentDocument__StyledLargeBadge",
  componentId: "sc-9685b4b-0"
})([
  `opacity:0.5;`
]);

export { ResourceContentDocument };
//# sourceMappingURL=ResourceContentDocument.js.map
